import { render } from "./TimerSettings.vue?vue&type=template&id=4529c1f1"
import script from "./TimerSettings.vue?vue&type=script&lang=js"
export * from "./TimerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__